import script from "./SocialFundCalls.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialFundCalls.vue?vue&type=script&setup=true&lang=js"

import "./SocialFundCalls.vue?vue&type=style&index=0&id=2c8e66c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c8e66c4"]])

export default __exports__